import React from 'react';

const useLocalStorage = (key: string, initialValue?: any, raw = false) => {
	const [stateValue, setStateValue] = React.useState(readStoredValue(key, raw) || initialValue || null);

	const setValue = React.useCallback(
		(value) => {
			saveStoredValue(key, value, raw);
			setStateValue(value);
		},
		[key, raw]
	);

	const deleteValue = React.useCallback(() => {
		removeStoredValue(key);
		setStateValue(null);
	}, [key]);

	return [stateValue, setValue, deleteValue];
};

export default useLocalStorage;

const readStoredValue = (key: string, raw: boolean) => {
	const storedValue = window.localStorage.getItem(key);

	if (raw) return storedValue;

	try {
		if (storedValue) return JSON.parse(storedValue);
	} catch (e) {
		window.localStorage.removeItem(key);
	}

	return null;
};

const saveStoredValue = (key: string, value: any, raw: boolean) => {
	window.localStorage.setItem(key, raw ? value : JSON.stringify(value));
};

const removeStoredValue = (key: string) => {
	window.localStorage.removeItem(key);
};
